<template>
  <div>
    <login-reg></login-reg>
  </div>
</template>

<script>
export default{
  name:"vue-zhaobi-login"
} 
</script>



// WEBPACK FOOTER //
// src/views/login/hello.vue